
<input matInput class="mat-select-search-input mat-select-search-hidden" />

<div class="mat-select-search-inner" [ngClass]="{'mat-select-search-inner-multiple': matSelect.multiple}">
  <input matInput
         [attr.aria-label]="placeholderLabel"
         class="mat-select-search-input"
         #searchSelectInput
         (keydown)="_handleKeydown($event)"
         (input)="onInputChange($event)"
         (blur)="onBlur($event)"
         [placeholder]="placeholderLabel"
         autocomplete="off"/>

  <span *ngIf="value" class="mat-select-search-clear btn-close" (click)="_reset(true)" aria-label="Clear"></span>
</div>

<div *ngIf="noEntriesFoundLabel && value && _options?.length === 0" class="mat-select-search-no-entries-found">
  {{noEntriesFoundLabel}}
</div>
